/**
 * Ajax addtocart Btn
 * ======================================
 * - jquery needed
 * - handled with ajax/index.php
 */
import $ from "jquery";
import { diffTableTippyConfig } from "../components/diff-table";
import { diffTable } from "../components/diff-table";

const $body = $("body");
const $difftable = $("#diff-table");
const $difftablecore = $difftable.children(".diff-table");
const $difftablemessage = $("#diff-table-message");

const $compareButton = $("#compare-button");
const $compareCount = $(".js-compare-count");
const $compareButtonString = $(".js-compare-button-string");
const $comparePageString = $(".js-compare-page-string");

function diffbutton(action, $el) {
	if (action == "add") {
		$el
			.removeClass("disabled js-addtocompare")
			.addClass("js-removefromcompare active");

		$el.find("span").removeAttr("hidden");
	} else if (action == "remove") {
		$el
			.removeClass("disabled js-removefromcompare active")
			.addClass("js-addtocompare");

		$el.find("span").attr("hidden", "hidden");
	}
}

function diffcounter(response) {
	$compareCount.html(response.count);
	$comparePageString.html(response.countString.page);
	$compareButtonString.html(response.countString.button);

	if (response.count > 0) {
		$compareButton.removeClass("is-hidden");

		$difftable.removeAttr("hidden");
		$difftablemessage.attr("hidden", "hidden");
	} else {
		$compareButton.addClass("is-hidden");

		$difftable.attr("hidden", "hidden");
		$difftablemessage.removeAttr("hidden");
	}

	// view
	if (response.count > 2) {
		$difftablecore.addClass("diff-table-multi");
	} else {
		$difftablecore.removeClass("diff-table-multi");
	}
}

function difftable(action, id, response, counter = true) {
	const $select = $('.comparison-select__item[data-id="' + id + '"]');

	const $scriptSelectTemplate = $($(".js-diff-select-list").html());
	const $scriptSelect = $scriptSelectTemplate.find(
		'.comparison-select__item[data-id="' + id + '"]'
	);

	const tplWrapper = document.querySelector(".js-diff-select-list");

	if (action == "add") {
		$([$select, $scriptSelect]).each(function() {
			var $this = $(this);

			diffbutton("add", $this);

			$this
				.find(".icon--circle_plus")
				.parent()
				.attr("hidden", "hidden");
			$this
				.find(".icon--circle_minus")
				.parent()
				.removeAttr("hidden");
		});

		$scriptSelectTemplate
			.find(".comparison-select__item")
			.removeClass("js-removefromcompare");

		tplWrapper.innerHTML = $scriptSelectTemplate[0].outerHTML;
	} else if (action == "remove") {
		$([$select, $scriptSelect]).each(function() {
			var $this = $(this);

			diffbutton("remove", $this);

			$this
				.find(".icon--circle_plus")
				.parent()
				.removeAttr("hidden");
			$this
				.find(".icon--circle_minus")
				.parent()
				.attr("hidden", "hidden");
		});

		$scriptSelectTemplate
			.find(".comparison-select__item")
			.removeClass("js-addtocompare");

		tplWrapper.innerHTML = $scriptSelectTemplate[0].outerHTML;
	}

	if (counter) {
		diffcounter(response);
	}
}

function ajax(action, data, response) {
	if (action == "change") {
		// ids
		var id = data[0];
		var current = data[1];
		var $this = data[2];

		var $button = $(
			'.js-diff-table .js-diff-select-trigger[data-current="' + current + '"]'
		);

		$(".js-diff-table .js-sticky")
			.find('[data-index="' + current + '"]')
			.attr("data-index", id);
		$('.diff-table__header-item[data-index="' + current + '"]').attr(
			"data-index",
			id
		);
		$('.diff-table__row-term[data-index="' + current + '"]').attr(
			"data-index",
			id
		);
		$('.js-diff-table .js-removefromcompare[data-id="' + current + '"]').attr(
			"data-id",
			id
		);
		$button.attr("data-current", id);

		$this.closest(".dropdown-select").attr("data-current", id);

		//html
		var $header = $('.diff-table__header-item[data-index="' + id + '"]');
		$header.find(".diff-table__product-title span").html(response.product.name);
		$header.find(".diff-table__product-subtitle").html(response.product.price);
		$header
			.find(".diff-table__product-image a")
			.attr("href", response.product.link);
		$header
			.find(".diff-table__product-image img")
			.attr("src", response.product.img.src);
		$header
			.find(".diff-table__product-image img")
			.attr("srcset", response.product.img.src2x + " 2x");

		var $terms = $('.diff-table__row-term[data-index="' + id + '"]');

		$terms.each(function(index) {
			var $this = $(this);
			var value = response.product.functions_ajax[index];

			if (value == true) {
				var value = response.html.iconcheck;
			}

			$this.html(value);
		});
	} else if (action == "add") {
		var $header = $(".diff-table__header-list.diff-table-sticky");
		var $list = $(".diff-table__row-list.diff-table-sticky");

		$header.append(response.html.header);

		tippy(".js-diff-select-trigger", diffTableTippyConfig);

		$list.each(function(index) {
			var $this = $(this);
			var value = response.product.functions_ajax[index];

			if (value == true) {
				var value = response.html.iconcheck;
			} else if (value == false) {
				var value = "";
			}

			var $term = $(response.html.term);
			$term.html(value);

			$this.append($term);
		});
	}
}

$body.on("click", ".js-addtocompare", function(e) {
	const $this = $(this);
	const id = $this.attr("data-id");
	const button = $this.attr("data-button");

	var data = new FormData();
	data.append("action", "addtocompare");
	data.append("product", id);

	// ajax js
	const xhr = new XMLHttpRequest();
	xhr.open("POST", ajaxUrl + "/index.php", true);
	$this.addClass("disabled");
	xhr.send(data);

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.response);

				if (button) {
					diffbutton("add", $(".js-addtocompare"));
					diffcounter(response);
				} else {
					difftable("add", id, response);
					ajax("add", false, response);

					diffTable.slideEnd();
				}
			} else {
				console.log("ajaxForm error!", xhr);
			}
		}
	};

	e.preventDefault();
});

$body.on("click", ".js-removefromcompare", function(e) {
	const $this = $(this);
	const id = $this.attr("data-id");
	const button = $this.attr("data-button");

	var data = new FormData();
	data.append("action", "removefromcompare");
	data.append("product", id);

	// ajax js
	const xhr = new XMLHttpRequest();
	xhr.open("POST", ajaxUrl + "/index.php", true);
	$this.addClass("disabled");
	xhr.send(data);

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.response);

				if (button) {
					diffbutton("remove", $(".js-removefromcompare"));
					diffcounter(response);
				} else {
					difftable("remove", id, response);

					$difftable.find('[data-index="' + id + '"]').remove();

					diffTable.slidePrev();
				}
			} else {
				console.log("ajaxForm error!", xhr);
			}
		}
	};

	e.preventDefault();
});

$body.on("click", ".js-changecompare", function(e) {
	const $this = $(this);
	const id = $this.attr("data-id");
	const current = $this.closest(".dropdown-select").attr("data-current");
	const widget = $this.closest(".dropdown-select").attr("data-widget");

	var data = new FormData();
	data.append("action", "changecompare");
	data.append("product", id);
	data.append("current", current);
	data.append("widget", widget ? true : false);

	// ajax js
	const xhr = new XMLHttpRequest();
	xhr.open("POST", ajaxUrl + "/index.php", true);
	$this.addClass("disabled");
	xhr.send(data);

	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.response);

				difftable("remove", current, response, false);
				difftable("add", id, response);
				ajax("change", [id, current, $this], response);
			} else {
				console.log("ajaxForm error!", xhr);
			}
		}
	};

	e.preventDefault();
});
